/*
 * @Author: your name
 * @Date: 2022-03-05 17:08:20
 * @LastEditTime: 2025-03-11 10:39:31
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyUserThumbList\index.jsx
 */
import React, { Component } from "react";

import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsyMsgBubble from "../BsyMsgBubble";
import BsyDeptUserPane from "../BsyDeptUserPane";

export default class BsyUserThumbList extends Component {
  static defaultProps = {
    list: [],
    is_dock_form: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      list: props.list,
      is_dock_form: props.is_dock_form,
      appId: props.appId,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      ...nextProps,
    });
  }

  loadData = (data, cb) => {
    const { appId, is_dock_form } = this.state;
    if (is_dock_form) {
      return;
    }
    if (!data.id) {
      return;
    }
    React.axios("/data/member/hover_detail", {
      user_id: data.id,
      appId: appId || window.FX.STATIC.APPID,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          cb && cb(res.data);
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  showUserInfo = (data, t) => {
    if (window.FX.STATIC.QTOKEN) {
      return;
    }

    this.loadData(data, (info) => {
      BsyMsgBubble({
        anchor: t.target,
        contentHTML: (ref) => {
          // if (info.status === -2) {
          //     return <div className="tips">{"该成员已离职"}</div>
          // }
          return <BsyDeptUserPane type={"user"} info={{ ...info }} />;
        },
        text4Cancel: null,
        text4Ok: null,
        theme: this.props.theme,
        minWidth: "auto",
        width: 300,
        contentPadding: 0,
        edge: 200,
        hAdjust: 72,
        dockPosition: "left",
        onClose: function () {
          return !1;
        },
      });
    });
  };

  renderItem = (data) => {
    const { nickname, avatarurl, id, status } = data;
    const bg = nickname ? BsyUtils.formatUserThumb(nickname.toString()) : "";

    return (
      <span className={"table-user-name"}>{BsyUtils._toDeptUser(data)}</span>
    );
  };

  render() {
    const { list } = this.state;
    return (
      <div className="bsy-user-thumb-list">
        {!list
          ? ""
          : list.map((data, index) => {
              let errorStyle = data.status === -99 || data.status === -2;
              if (BsyUtils.isString(data)) {
                data = window.userSelectMap[data] || data;
              }
              let id = data.id || data._id;
              let name = BsyUtils._toDeptUser(data);
              return index === 0 ? (
                <>
                  <span
                    className={
                      "name" +
                      (data.status === -99 || data.status === -2
                        ? " error"
                        : "")
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      this.showUserInfo(data, e);
                    }}
                  >
                    {name}
                  </span>
                </>
              ) : (
                <>
                  <span>,</span>
                  <span
                    className={
                      "name" +
                      (data.status === -99 || data.status === -2
                        ? " error"
                        : "")
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      this.showUserInfo(data, e);
                    }}
                  >
                    {name}
                  </span>
                </>
              );
            })}
      </div>
    );
  }
}
